
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAisAtonVirtualIec as ObiAisAtonVirtualIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-ais-aton-virtual-iec.js';
 
 
 

 
 export const ObiAisAtonVirtualIec = createComponent({
   react: React,
   tagName: 'obi-ais-aton-virtual-iec',
   elementClass: ObiAisAtonVirtualIecElement,
   events: {
     
   }
  });
 
 